import cx from 'classnames';
import type { PropsWithChildren } from 'react';
import React from 'react';

export interface DataTableProps extends PropsWithChildren {
	customClasses?: string;
	noStripped?: boolean;
	responsive?: boolean;
	stripedVariant?: 'odd' | 'even';
}

export const DataTable = ({
	children,
	customClasses,
	noStripped,
	responsive,
	stripedVariant,
}: DataTableProps) => {
	const responsiveClass = responsive ? 'table-responsive' : '';
	const stripedTable = noStripped ? '' : 'table-striped';
	const stripedVariantClass = stripedVariant ? stripedVariant : 'even';

	return (
		<table
			className={cx(
				responsiveClass,
				stripedTable,
				'striped-' + stripedVariantClass,
				customClasses
			)}>
			{children}
		</table>
	);
};
